module.exports = __webpack_public_path__ + "static/media/howItWorks_5.6356c350.svg";